import { LogOutIcon, MoreVerticalIcon } from 'lucide-react'

import { useNavUser } from 'src/features/NavUser/useNavUser'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from 'src/components/shadcn/sidebar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from 'src/components/shadcn/dropdown-menu'
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from 'src/components/shadcn/avatar'

export const NavUser = (): JSX.Element => {
  const { isMobile, userName, mail, photoURL, handleLogout } = useNavUser()

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              {photoURL && (
                <Avatar className="h-8 w-8 rounded-[10px]">
                  <AvatarImage src={photoURL} alt={userName} />
                  <AvatarFallback className="rounded-[10px]">CN</AvatarFallback>
                </Avatar>
              )}
              <div className="grid flex-1 text-left text-sm leading-tight">
                <span className="truncate font-medium">{userName}</span>
                <span className="truncate text-xs text-muted-foreground">
                  {mail}
                </span>
              </div>
              <MoreVerticalIcon className="ml-auto size-4" />
            </SidebarMenuButton>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
            side={isMobile ? 'bottom' : 'right'}
            align="end"
            sideOffset={4}
          >
            <DropdownMenuLabel className="p-0 font-normal">
              <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                {photoURL && (
                  <Avatar className="h-8 w-8 rounded-[10px]">
                    <AvatarImage src={photoURL} alt={userName} />
                    <AvatarFallback className="rounded-[10px]">
                      CN
                    </AvatarFallback>
                  </Avatar>
                )}
                <div className="grid flex-1 text-left text-sm leading-tight">
                  <span className="truncate font-medium">{userName}</span>
                  <span className="truncate text-xs text-muted-foreground">
                    {mail}
                  </span>
                </div>
              </div>
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleLogout}>
              <LogOutIcon />
              Log out
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
